export default __webpack_public_path__ + "static/media/EtihadCargo.3d625262.jpg";